// extracted by mini-css-extract-plugin
export default {"cls1":"Truncate-cls1_Ae_","cls2":"Truncate-cls2_DZe Truncate-cls1_Ae_"};